import { usePage } from '@inertiajs/inertia-react'
import Grid from '@mui/material/Grid'
import VoucherDetail from './VoucherDetail'
import VoucherPos from './VoucherPos'

const VoucherShow = () => {
  const {
    props: { voucher },
  } = usePage()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <VoucherDetail voucher={voucher} />
      </Grid>

      <Grid item xs={12}>
        <VoucherPos />
      </Grid>
    </Grid>
  )
}

export default VoucherShow
